/**
 * State segment for tracking image feedback
 * Stores feedback state (liked/disliked/loading) per image ID
 */

import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import { ImageFeedbackMap } from '../../../types/ReferenceFeedback';

export const imageFeedbackStateSegment =
  stateSegmentWithReset<ImageFeedbackMap>({});

imageFeedbackStateSegment.debugLabel = 'imageFeedbackStateSegment';
